"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolvePlatform = exports.resolveFallbackUrl = exports.getReferralCode = exports.buildWebSignupUrl = exports.buildPlayStoreUrl = exports.buildMainWebsiteUrl = exports.buildAppUrl = void 0;
var ANDROID_PACKAGE = "skylifestyle.mobile";
var IOS_APP_STORE_URL = "https://apps.apple.com/us/app/skylifestyle-mobile/id6456845292";
/** Reads current and legacy referral parameters so previously shared links keep working. */
function getReferralCode(search) {
    var _a, _b;
    var searchParameters = new URLSearchParams(search);
    var currentCode = (_a = searchParameters.get("code")) === null || _a === void 0 ? void 0 : _a.trim();
    return currentCode || ((_b = searchParameters.get("referral_code")) === null || _b === void 0 ? void 0 : _b.trim()) || "";
}
exports.getReferralCode = getReferralCode;
/** Determines which app-store fallback is appropriate for the current browser. */
function resolvePlatform(userAgent) {
    if (/Android/i.test(userAgent)) {
        return "android";
    }
    if (/iPhone|iPad|iPod/i.test(userAgent)) {
        return "ios";
    }
    return "web";
}
exports.resolvePlatform = resolvePlatform;
/** Creates the custom-scheme link used when a browser does not open a verified link. */
function buildAppUrl(code, sourceUrl) {
    var appUrl = new URL("skylifestyle://open");
    appUrl.searchParams.set("code", code);
    appUrl.searchParams.set("web_url", sourceUrl);
    return appUrl.toString();
}
exports.buildAppUrl = buildAppUrl;
/**
 * Preserves the exact Google Play campaign payload used by the working
 * production referral page.
 */
function buildPlayStoreUrl(code) {
    var installReferrer = new URLSearchParams({
        utm_source: "google",
        utm_medium: "browser",
        code: code,
    });
    var storeUrl = new URL("https://play.google.com/store/apps/details");
    storeUrl.searchParams.set("id", ANDROID_PACKAGE);
    storeUrl.searchParams.set("referrer", installReferrer.toString());
    return storeUrl.toString();
}
exports.buildPlayStoreUrl = buildPlayStoreUrl;
function buildMainWebsiteUrl(origin) {
    return "".concat(origin, "/#/home");
}
exports.buildMainWebsiteUrl = buildMainWebsiteUrl;
function buildWebSignupUrl(origin, code) {
    return "".concat(buildMainWebsiteUrl(origin), "?referral_code=").concat(encodeURIComponent(code));
}
exports.buildWebSignupUrl = buildWebSignupUrl;
function resolveFallbackUrl(platform, code, origin) {
    if (platform === "android") {
        return buildPlayStoreUrl(code);
    }
    if (platform === "ios") {
        return IOS_APP_STORE_URL;
    }
    return buildWebSignupUrl(origin, code);
}
exports.resolveFallbackUrl = resolveFallbackUrl;
